// extracted by mini-css-extract-plugin
export default {"averageBuildableSquareFeet":"tp5LgOLD7jVPKonP0S2K","stat":"SBQNPr59Qrqs5LGqCLVj","tooltip":"ShiKymNrFSi3UYtawL6I"};